<div class="page-container" testId="personal-broadcast-detail-page">
  <div class="page-topbar" testId="personal-broadcast-detail-topbar">
    <div class="page-header" testId="personal-broadcast-detail-header">
      <div class="page-heading">
        <div class="page-title-row">
          <button nz-button nzType="text" class="back-icon" (click)="back()" testId="personal-broadcast-detail-back-button">
            <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
          </button>
          <div class="title-section">
            <h1 testId="personal-broadcast-detail-title">{{
              isCreate ? ('personal-broadcast.detail.title.create' | i18n) : ('personal-broadcast.detail.title.edit' | i18n)
            }}</h1>
            <p testId="personal-broadcast-detail-subtitle">{{ 'personal-broadcast.detail.subtitle' | i18n }}</p>
          </div>
        </div>
      </div>
      <div class="page-actions">
        <button
          nz-button
          nzType="primary"
          class="send-btn"
          (click)="onSendClick()"
          [nzLoading]="submitting"
          [disabled]="!canSend || submitting"
          testId="personal-broadcast-detail-send-button"
        >
          {{ actionLabel }}
        </button>
        <button
          *ngIf="!isCreate"
          nz-button
          nzDanger
          nzType="default"
          (click)="deleteTask()"
          testId="personal-broadcast-detail-delete-button"
        >
          <i nz-icon nzType="delete" nzTheme="outline"></i>{{ 'common.delete' | i18n }}
        </button>
      </div>
    </div>
  </div>

  <nz-spin [nzSpinning]="loading" class="page-spin" testId="personal-broadcast-detail-spin">
    <div class="page-scroll" testId="personal-broadcast-detail-page-scroll">
      <div class="form-layout" testId="personal-broadcast-detail-layout">
        <div class="main-left">
          <nz-card class="section-card" [nzTitle]="'personal-broadcast.detail.section.base' | i18n">
            <form nz-form [formGroup]="form" nzLayout="vertical" testId="personal-broadcast-detail-base-form">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'personal-broadcast.detail.field.title' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="title"
                    [placeholder]="'personal-broadcast.detail.placeholder.title' | i18n"
                    testId="personal-broadcast-detail-title-input"
                  />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'personal-broadcast.detail.field.remark' | i18n }}</nz-form-label>
                <nz-form-control>
                  <textarea
                    nz-input
                    rows="2"
                    formControlName="remark"
                    [placeholder]="'personal-broadcast.detail.placeholder.remark' | i18n"
                    testId="personal-broadcast-detail-remark-textarea"
                  ></textarea>
                </nz-form-control>
              </nz-form-item>

              <div class="form-divider" *ngIf="requiresChannel"></div>
              <div class="form-section" *ngIf="requiresChannel">
                <div class="form-section-title">
                  <span class="required-mark">*</span>
                  <span>{{ 'personal-broadcast.detail.field.channel' | i18n }}</span>
                </div>
                <nz-radio-group formControlName="channel" class="channel-grid" testId="personal-broadcast-detail-channel-radio-group">
                  <label
                    *ngFor="let option of channelOptions"
                    nz-radio
                    class="channel-card"
                    [nzValue]="option.value"
                    [nzDisabled]="option.disabled"
                  >
                    <img *ngIf="option.icon" [src]="option.icon" [alt]="option.label" />
                    <i *ngIf="!option.icon" nz-icon nzType="star" nzTheme="outline"></i>
                    <span>{{ option.label }}</span>
                  </label>
                </nz-radio-group>
              </div>
            </form>
          </nz-card>

          <nz-card class="section-card" [nzTitle]="'personal-broadcast.detail.section.messages' | i18n">
            <form nz-form [formGroup]="form" nzLayout="vertical" testId="personal-broadcast-detail-message-form">
              <div class="message-header">
                <div class="message-title">
                  <label nz-checkbox formControlName="messageEnabled">{{ 'personal-broadcast.detail.field.messages' | i18n }}</label>
                  <span class="message-count">{{ messagesArray.length }}/5</span>
                </div>
                <span class="message-tip">{{ 'personal-broadcast.detail.message.tip' | i18n }}</span>
              </div>
              <div class="message-list">
                <div
                  class="message-item"
                  *ngFor="let grp of messagesArray.controls; let i = index; trackBy: trackByIndex"
                  [formGroup]="grp"
                  [class.is-disabled]="!messageEnabled"
                  [testId]="'personal-broadcast-detail-message-item-' + i"
                >
                  <div class="message-item-header">
                    <div class="message-item-header-left">
                      <span class="message-index">{{ 'personal-broadcast.detail.message.index' | i18n: { index: i + 1 } }}</span>
                      <nz-select
                        formControlName="type"
                        class="message-type-select"
                        [nzDisabled]="!messageEnabled"
                        [testId]="'personal-broadcast-detail-message-type-select-' + i"
                      >
                        <nz-option *ngFor="let t of messageTypes" [nzLabel]="t.displayLabel" [nzValue]="t.value" />
                      </nz-select>
                    </div>
                    <div class="message-item-header-actions">
                      <button
                        nz-button
                        nzType="text"
                        class="message-action-btn"
                        (click)="toggleMessageCollapse(i)"
                        [disabled]="!messageEnabled"
                        [testId]="'personal-broadcast-detail-message-collapse-button-' + i"
                      >
                        <i nz-icon [nzType]="grp.get('collapsed')?.value ? 'down' : 'up'" nzTheme="outline"></i>
                      </button>
                      <button
                        nz-button
                        nzType="text"
                        nzDanger
                        class="message-action-btn"
                        (click)="removeMessage(i)"
                        [disabled]="messagesArray.length === 1 || !messageEnabled"
                        [testId]="'personal-broadcast-detail-message-remove-button-' + i"
                      >
                        <i nz-icon nzType="close" nzTheme="outline"></i>
                      </button>
                    </div>
                  </div>
                  <div class="message-item-content" *ngIf="!grp.get('collapsed')?.value">
                    <div [ngSwitch]="grp.get('type')?.value">
                      <div *ngSwitchCase="'text'" class="message-type-panel" formGroupName="text">
                        <div class="text-editor">
                          <textarea
                            #textArea
                            nz-input
                            rows="3"
                            maxlength="200"
                            formControlName="content"
                            [placeholder]="'personal-broadcast.detail.placeholder.text-message' | i18n"
                            [disabled]="!messageEnabled"
                            [testId]="'personal-broadcast-detail-text-message-textarea-' + i"
                          ></textarea>
                          <div class="text-count">{{ grp.get(['text', 'content'])?.value?.length || 0 }}/200</div>
                        </div>
                        <div class="variable-row">
                          <span class="variable-label">{{ 'personal-broadcast.detail.text.variable-label' | i18n }}</span>
                          <button
                            *ngFor="let v of textVariables"
                            nz-button
                            nzType="default"
                            nzSize="small"
                            class="variable-chip"
                            (click)="insertTextVariable(textArea, grp, v.token)"
                            [disabled]="!messageEnabled"
                            type="button"
                            [testId]="'personal-broadcast-detail-text-variable-button-' + i + '-' + v.token"
                          >
                            {{ v.token }} {{ v.label }}
                          </button>
                        </div>
                        <div class="text-hint">
                          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                          <span>{{ 'personal-broadcast.detail.text.variable-hint' | i18n }}</span>
                        </div>
                      </div>

                      <div *ngSwitchCase="'template'" class="message-type-panel template-panel">
                        <div formGroupName="template" class="template-fields">
                          <div class="field">
                            <div class="field-label">
                              <span class="required-mark">*</span>
                              <span>{{ 'personal-broadcast.detail.template.title' | i18n }}</span>
                            </div>
                            <input
                              nz-input
                              formControlName="title"
                              [placeholder]="'personal-broadcast.detail.placeholder.template-title' | i18n"
                              [disabled]="!messageEnabled"
                              [testId]="'personal-broadcast-detail-template-title-input-' + i"
                            />
                          </div>
                          <div class="field">
                            <div class="field-label">{{ 'personal-broadcast.detail.template.subtitle' | i18n }}</div>
                            <input
                              nz-input
                              formControlName="subtitle"
                              [placeholder]="'personal-broadcast.detail.placeholder.template-subtitle' | i18n"
                              [disabled]="!messageEnabled"
                              [testId]="'personal-broadcast-detail-template-subtitle-input-' + i"
                            />
                          </div>
                        </div>

                        <div class="field">
                          <div class="field-label">{{ 'personal-broadcast.detail.template.image' | i18n }}</div>
                          <div formGroupName="templateImage" class="upload-wrapper">
                            <input
                              #templateImageInput
                              type="file"
                              accept="image/*"
                              class="file-native-input"
                              (change)="onSelectImageFile(grp, $event, 'templateImage')"
                              [disabled]="!messageEnabled"
                              [testId]="'personal-broadcast-detail-template-image-input-' + i"
                            />
                            <ng-container *ngIf="!grp.get(['templateImage', 'previewUrl'])?.value; else templateImagePreview">
                              <div
                                class="native-upload-zone"
                                [class.is-disabled]="!messageEnabled"
                                (click)="openNativeFilePicker(templateImageInput)"
                              >
                                <div class="native-upload-icon"><i nz-icon nzType="upload" nzTheme="outline"></i></div>
                                <div class="native-upload-text">{{ 'personal-broadcast.detail.upload.select-image' | i18n }}</div>
                                <div class="native-upload-hint">{{ 'personal-broadcast.detail.upload.image-hint' | i18n }}</div>
                              </div>
                            </ng-container>
                            <ng-template #templateImagePreview>
                              <div class="upload-preview-container">
                                <img class="upload-preview" [src]="grp.get(['templateImage', 'previewUrl'])?.value" alt="template" />
                                <div
                                  class="upload-preview-mask"
                                  (click)="openNativeFilePicker(templateImageInput)"
                                  [class.disabled]="!messageEnabled"
                                >
                                  <div class="upload-preview-mask-text">{{ 'common.reselect' | i18n }}</div>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>

                        <div class="template-buttons" formGroupName="template">
                          <div class="template-buttons-header">
                            <span class="field-label">{{ 'personal-broadcast.detail.template.buttons' | i18n }}</span>
                            <button
                              nz-button
                              nzType="default"
                              nzSize="small"
                              class="template-add-btn"
                              (click)="addTemplateButton(grp)"
                              [disabled]="getTemplateButtons(grp).length >= 3 || !messageEnabled"
                              [testId]="'personal-broadcast-detail-template-add-button-' + i"
                            >
                              <i nz-icon nzType="plus" nzTheme="outline"></i>
                              {{ 'personal-broadcast.detail.template.add-button' | i18n }}
                            </button>
                          </div>

                          <div class="template-buttons-empty" *ngIf="getTemplateButtons(grp).length === 0">
                            {{ 'personal-broadcast.detail.template.no-buttons' | i18n }}
                          </div>

                          <div class="template-button-list" formArrayName="buttons" *ngIf="getTemplateButtons(grp).length > 0">
                            <div
                              class="template-button-item"
                              *ngFor="let btn of getTemplateButtons(grp).controls; let bi = index"
                              [formGroup]="btn"
                            >
                              <div class="template-button-item-title">
                                <span>{{ 'personal-broadcast.detail.template.button-index' | i18n: { index: bi + 1 } }}</span>
                                <button
                                  nz-button
                                  nzType="text"
                                  nzDanger
                                  class="message-action-btn"
                                  (click)="removeTemplateButton(grp, bi)"
                                  [disabled]="!messageEnabled"
                                  [testId]="'personal-broadcast-detail-template-remove-button-' + i + '-' + bi"
                                >
                                  <i nz-icon nzType="close" nzTheme="outline"></i>
                                </button>
                              </div>
                              <div class="template-button-row">
                                <input
                                  nz-input
                                  class="template-button-display-input"
                                  [value]="getTemplateButtonText(btn)"
                                  [placeholder]="'personal-broadcast.detail.placeholder.button-text' | i18n"
                                  readonly
                                  tabindex="-1"
                                  [testId]="'personal-broadcast-detail-template-button-text-input-' + i + '-' + bi"
                                />
                                <button
                                  nz-button
                                  nzType="default"
                                  class="template-button-config-btn"
                                  (click)="openButtonActionConfig(btn, bi)"
                                  [disabled]="!messageEnabled"
                                  type="button"
                                  [testId]="'personal-broadcast-detail-template-button-config-button-' + i + '-' + bi"
                                >
                                  <i nz-icon nzType="setting" nzTheme="outline"></i>
                                  {{ 'personal-broadcast.detail.template.config-action' | i18n }}
                                </button>
                              </div>
                              <div class="template-button-summary">{{ getTemplateButtonActionSummary(btn) }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngSwitchCase="'image'" class="message-type-panel" formGroupName="image">
                        <div class="upload-wrapper">
                          <input
                            #imageInput
                            type="file"
                            accept="image/*"
                            class="file-native-input"
                            (change)="onSelectImageFile(grp, $event, 'image')"
                            [disabled]="!messageEnabled"
                            [testId]="'personal-broadcast-detail-image-input-' + i"
                          />
                          <ng-container *ngIf="!grp.get(['image', 'previewUrl'])?.value; else imagePreview">
                            <div
                              class="native-upload-zone"
                              [class.is-disabled]="!messageEnabled"
                              (click)="openNativeFilePicker(imageInput)"
                            >
                              <div class="native-upload-icon"><i nz-icon nzType="upload" nzTheme="outline"></i></div>
                              <div class="native-upload-text">{{ 'personal-broadcast.detail.upload.select-image' | i18n }}</div>
                              <div class="native-upload-hint">{{ 'personal-broadcast.detail.upload.image-hint' | i18n }}</div>
                            </div>
                          </ng-container>
                          <ng-template #imagePreview>
                            <div class="upload-preview-container">
                              <img class="upload-preview" [src]="grp.get(['image', 'previewUrl'])?.value" alt="image" />
                              <div
                                class="upload-preview-mask"
                                (click)="openNativeFilePicker(imageInput)"
                                [class.disabled]="!messageEnabled"
                              >
                                <div class="upload-preview-mask-text">{{ 'common.reselect' | i18n }}</div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>

                      <div *ngSwitchCase="'file'" class="message-type-panel file-panel" formGroupName="file">
                        <div class="file-select">
                          <button
                            class="file-select-btn is-block"
                            [disabled]="!messageEnabled"
                            type="button"
                            (click)="openAttachmentPicker(i, attachmentPicker)"
                            [testId]="'personal-broadcast-detail-file-select-button-' + i"
                          >
                            <i nz-icon nzType="upload" nzTheme="outline"></i>
                            <span>{{ 'personal-broadcast.detail.upload.select-file' | i18n }}</span>
                          </button>
                          <div class="file-selected" *ngIf="grp.get(['file', 'name'])?.value; else filePlaceholder">
                            {{ grp.get(['file', 'name'])?.value }}
                          </div>
                          <ng-template #filePlaceholder>
                            <div class="file-placeholder">{{ 'personal-broadcast.detail.upload.no-file' | i18n }}</div>
                          </ng-template>
                        </div>
                        <div class="upload-hint">{{ 'personal-broadcast.detail.upload.file-hint' | i18n }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="message-actions">
                <button
                  nz-button
                  nzType="default"
                  class="message-add-btn"
                  (click)="addMessage('text')"
                  [disabled]="messagesArray.length >= 5 || !messageEnabled"
                  type="button"
                  testId="personal-broadcast-detail-add-text-button"
                >
                  <i nz-icon nzType="message" nzTheme="outline"></i>
                  {{ 'personal-broadcast.detail.message-type.text' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  class="message-add-btn"
                  (click)="addMessage('image')"
                  [disabled]="messagesArray.length >= 5 || !messageEnabled"
                  type="button"
                  testId="personal-broadcast-detail-add-image-button"
                >
                  <i nz-icon nzType="picture" nzTheme="outline"></i>
                  {{ 'personal-broadcast.detail.message-type.image' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  class="message-add-btn"
                  (click)="addMessage('file')"
                  [disabled]="messagesArray.length >= 5 || !messageEnabled"
                  type="button"
                  testId="personal-broadcast-detail-add-file-button"
                >
                  <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
                  {{ 'personal-broadcast.detail.message-type.file' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  class="message-add-btn"
                  (click)="addMessage('template')"
                  [disabled]="messagesArray.length >= 5 || !messageEnabled"
                  type="button"
                  testId="personal-broadcast-detail-add-template-button"
                >
                  <i nz-icon nzType="appstore" nzTheme="outline"></i>
                  {{ 'personal-broadcast.detail.message-type.template' | i18n }}
                </button>
              </div>
              <input
                #attachmentPicker
                type="file"
                class="file-native-input"
                (change)="onSelectAttachmentFromPicker($event)"
                [disabled]="!messageEnabled"
                testId="personal-broadcast-detail-attachment-input"
              />
            </form>
          </nz-card>

          <nz-card class="section-card" [nzTitle]="'personal-broadcast.detail.section.targets' | i18n">
            <form nz-form [formGroup]="form" nzLayout="vertical" testId="personal-broadcast-detail-target-form">
              <div class="label-block" *ngIf="requiresCustomerLabels; else allInternalRecipients">
                <div class="label-block-header">
                  <div class="label-block-title">{{ 'personal-broadcast.detail.targets.tags' | i18n }}</div>
                  <div class="label-block-actions">
                    <span class="label-selected-count">{{
                      'personal-broadcast.detail.targets.selected-count' | i18n: { count: selectedLabelIdSet.size }
                    }}</span>
                    <button
                      nz-button
                      nzType="link"
                      class="label-clear-btn"
                      (click)="clearSelectedLabels()"
                      [disabled]="selectedLabelIdSet.size === 0"
                      type="button"
                      testId="personal-broadcast-detail-clear-labels-button"
                    >
                      {{ 'common.clear' | i18n }}
                    </button>
                  </div>
                </div>

                <div class="label-search">
                  <nz-input-group [nzPrefix]="labelSearchIcon">
                    <input
                      nz-input
                      [formControl]="labelSearchControl"
                      [placeholder]="'personal-broadcast.detail.targets.search-tags' | i18n"
                      testId="personal-broadcast-detail-label-search-input"
                    />
                  </nz-input-group>
                  <ng-template #labelSearchIcon>
                    <i nz-icon nzType="search" nzTheme="outline"></i>
                  </ng-template>
                </div>

                <div class="label-match-panel" *ngIf="selectedLabelIdSet.size > 0">
                  <div class="label-match-title">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    <span>{{ 'personal-broadcast.detail.targets.match-title' | i18n }}</span>
                  </div>
                  <nz-radio-group
                    formControlName="labelMatchMode"
                    class="label-match-group"
                    testId="personal-broadcast-detail-label-match-radio-group"
                  >
                    <label nz-radio nzValue="or">
                      {{ 'personal-broadcast.detail.targets.match.or' | i18n }}
                      <span class="label-match-badge is-or">OR</span>
                    </label>
                    <div class="label-match-desc">{{ 'personal-broadcast.detail.targets.match.or-desc' | i18n }}</div>
                    <label nz-radio nzValue="and">
                      {{ 'personal-broadcast.detail.targets.match.and' | i18n }}
                      <span class="label-match-badge is-and">AND</span>
                    </label>
                    <div class="label-match-desc">{{ 'personal-broadcast.detail.targets.match.and-desc' | i18n }}</div>
                  </nz-radio-group>
                </div>

                <div class="label-panel" [class.is-expanded]="labelPanelExpanded">
                  <nz-spin [nzSpinning]="labelLoading" nzSize="small">
                    <div class="label-list" (scroll)="onLabelPanelScroll($event)">
                      <nz-tag
                        *ngFor="let label of filteredLabelOptions"
                        nzMode="checkable"
                        [nzChecked]="selectedLabelIdSet.has(label.id)"
                        (nzCheckedChange)="onLabelCheckedChange(label, $event)"
                      >
                        <span class="label-name">{{ label.name }}</span>
                        <span class="label-contact-count" *ngIf="label.contactCount !== undefined">{{ label.contactCount }}</span>
                      </nz-tag>
                      <div class="label-empty" *ngIf="!labelLoading && !labelLoadingMore && labelOptions.length === 0">
                        {{ 'personal-broadcast.detail.targets.empty' | i18n }}
                      </div>
                      <div class="label-load-more" *ngIf="labelLoadingMore">{{
                        'personal-broadcast.detail.targets.loading-more' | i18n
                      }}</div>
                      <div
                        class="label-load-more is-end"
                        *ngIf="!labelLoading && !labelLoadingMore && !labelHasNext && labelOptions.length > 0"
                      >
                        {{ 'personal-broadcast.detail.targets.loaded-all' | i18n }}
                      </div>
                    </div>
                  </nz-spin>
                </div>

                <button
                  *ngIf="labelOptions.length > 0"
                  nz-button
                  nzType="link"
                  class="label-expand-btn"
                  (click)="toggleLabelPanel()"
                  type="button"
                  testId="personal-broadcast-detail-toggle-label-panel-button"
                >
                  {{
                    labelPanelExpanded
                      ? ('personal-broadcast.detail.targets.collapse' | i18n)
                      : ('personal-broadcast.detail.targets.expand' | i18n)
                  }}
                </button>
                <div class="label-hint">
                  {{ 'personal-broadcast.detail.targets.estimate' | i18n: { total: estimatedRecipientsText } }}
                </div>
              </div>

              <ng-template #allInternalRecipients>
                <div class="label-block" testId="personal-broadcast-detail-all-internal-recipients">
                  <div class="label-block-title">{{ 'personal-broadcast.detail.targets.all-internal' | i18n }}</div>
                  <div class="label-hint">{{ 'personal-broadcast.detail.targets.all-internal-desc' | i18n }}</div>
                </div>
              </ng-template>

              <div class="form-divider"></div>
              <div class="send-time-block">
                <div class="label-block-title">{{ 'personal-broadcast.detail.send-time.title' | i18n }}</div>
                <div class="send-time-row">
                  <nz-radio-group
                    formControlName="sendMode"
                    class="send-mode-group"
                    testId="personal-broadcast-detail-send-mode-radio-group"
                  >
                    <div class="send-mode-row">
                      <label nz-radio nzValue="immediate">{{ 'personal-broadcast.detail.send-time.immediate' | i18n }}</label>
                    </div>
                    <div class="send-mode-row">
                      <label nz-radio nzValue="scheduled">{{ 'personal-broadcast.detail.send-time.scheduled' | i18n }}</label>
                      <nz-date-picker
                        formControlName="sendAt"
                        [nzShowTime]="{ nzFormat: 'HH:mm' }"
                        nzFormat="yyyy/MM/dd HH:mm"
                        [nzPlaceHolder]="'personal-broadcast.detail.send-time.placeholder' | i18n"
                        class="send-at-picker"
                        [nzDisabled]="form.get('sendMode')?.value !== 'scheduled'"
                        [nzDisabledDate]="disableSendAtDate"
                        [nzDisabledTime]="disableSendAtTime"
                        testId="personal-broadcast-detail-send-at-picker"
                      />
                    </div>
                  </nz-radio-group>
                </div>
              </div>
            </form>
          </nz-card>
        </div>

        <div class="preview-right">
          <nz-card class="section-card preview-card" [nzTitle]="'personal-broadcast.detail.preview.title' | i18n">
            <ng-container *ngIf="previewMessages as msgs">
              <div class="preview-placeholder" *ngIf="msgs.length === 0">
                <img src="assets/images/flexIcon/phone.png" alt="phone" />
                <div>{{ 'personal-broadcast.detail.preview.empty.line1' | i18n }}</div>
                <div>{{ 'personal-broadcast.detail.preview.empty.line2' | i18n }}</div>
              </div>
              <div class="preview-content" *ngIf="msgs.length > 0">
                <div class="preview-phone">
                  <div class="preview-phone-header">
                    <div class="preview-phone-avatar"><i nz-icon nzType="user" nzTheme="outline"></i></div>
                    <div class="preview-phone-title">{{ 'personal-broadcast.detail.preview.default' | i18n }}</div>
                  </div>
                  <div class="preview-phone-body">
                    <div
                      class="preview-bubble"
                      *ngFor="let msg of msgs; trackBy: trackByIndex"
                      [class.is-image]="msg.type === 'image'"
                      [class.is-template]="msg.type === 'template'"
                    >
                      <ng-container [ngSwitch]="msg.type">
                        <div *ngSwitchCase="'text'" class="preview-bubble-text">
                          {{ msg.text || ('personal-broadcast.detail.preview.text-empty' | i18n) }}
                        </div>

                        <div *ngSwitchCase="'image'" class="preview-image">
                          <ng-container *ngIf="msg.imageUrl; else previewImageEmpty">
                            <img [src]="msg.imageUrl" alt="image" />
                          </ng-container>
                          <ng-template #previewImageEmpty>
                            <div class="preview-empty">{{ 'personal-broadcast.detail.preview.image-empty' | i18n }}</div>
                          </ng-template>
                          <div class="preview-file-name" *ngIf="msg.fileName">{{ msg.fileName }}</div>
                        </div>

                        <div *ngSwitchCase="'file'" class="preview-file">
                          <div class="preview-file-icon"><i nz-icon nzType="paper-clip" nzTheme="outline"></i></div>
                          <div class="preview-file-name">{{ msg.fileName || ('personal-broadcast.detail.preview.file-empty' | i18n) }}</div>
                        </div>

                        <div *ngSwitchCase="'template'" class="preview-template">
                          <div class="preview-template-image">
                            <ng-container *ngIf="msg.imageUrl; else previewTemplateImageEmpty">
                              <img [src]="msg.imageUrl" alt="template" />
                            </ng-container>
                            <ng-template #previewTemplateImageEmpty>
                              <div class="preview-template-image-empty">{{ 'personal-broadcast.detail.preview.image-empty' | i18n }}</div>
                            </ng-template>
                          </div>
                          <div class="preview-template-body">
                            <div class="preview-template-title">{{
                              msg.title || ('personal-broadcast.detail.preview.template-title-empty' | i18n)
                            }}</div>
                            <div class="preview-template-subtitle" *ngIf="msg.subtitle">{{ msg.subtitle }}</div>
                          </div>
                          <div class="preview-template-buttons" *ngIf="(msg.buttonTexts?.length || 0) > 0">
                            <div class="preview-template-button" *ngFor="let t of msg.buttonTexts || []">{{ t }}</div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="preview-phone-tip">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    <span>{{ 'personal-broadcast.detail.preview.tip' | i18n }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-card>
        </div>
      </div>
    </div>
  </nz-spin>

  <ng-template #sendConfirmTpl>
    <div class="confirm-row" testId="personal-broadcast-detail-confirm-targets">
      <div class="confirm-label">{{ 'personal-broadcast.detail.confirm.to' | i18n }}</div>
      <div class="confirm-value">
        {{ requiresCustomerLabels ? selectedLabelNames.join('、') || '—' : ('personal-broadcast.detail.targets.all-internal' | i18n) }}
      </div>
    </div>
    <div class="confirm-row" *ngIf="requiresCustomerLabels">
      <div class="confirm-label">{{ 'personal-broadcast.detail.confirm.estimate' | i18n }}</div>
      <div class="confirm-value">{{ 'personal-broadcast.detail.targets.estimate' | i18n: { total: estimatedRecipientsText } }}</div>
    </div>
    <div class="confirm-row">
      <div class="confirm-label">{{ 'personal-broadcast.detail.send-time.title' | i18n }}</div>
      <div class="confirm-value">{{ sendTimeText }}</div>
    </div>
  </ng-template>

  <nz-modal
    [(nzVisible)]="buttonActionConfigVisible"
    [nzTitle]="buttonActionConfigTitle"
    [nzWidth]="buttonActionConfigWidth"
    nzCentered
    nzWrapClassName="button-action-config-modal"
    [nzBodyStyle]="{ 'max-height': '70vh', overflow: 'auto' }"
    (nzOnCancel)="closeButtonActionConfig()"
    (nzOnOk)="handleButtonActionConfigOk()"
    [nzOkDisabled]="!messageEnabled || isButtonActionConfigInvalid()"
    [nzOkText]="'personal-broadcast.detail.button-action.done' | i18n"
    [nzCancelText]="'common.cancel' | i18n"
    testId="personal-broadcast-detail-button-action-modal"
  >
    <ng-container *nzModalContent>
      <ng-container *ngIf="buttonActionConfigBtn as btn">
        <div class="button-action-modal" [formGroup]="btn">
          <div class="button-action-section">
            <div class="field-label">
              <span class="required-mark">*</span>
              <span>{{ 'personal-broadcast.detail.template.button-text' | i18n }}</span>
            </div>
            <input
              nz-input
              formControlName="text"
              [placeholder]="'personal-broadcast.detail.placeholder.button-text' | i18n"
              maxlength="20"
              required
              [disabled]="!messageEnabled"
              testId="personal-broadcast-detail-button-action-text-input"
            />
            <div class="button-action-error" *ngIf="showButtonConfigControlError('text')">
              {{ 'personal-broadcast.detail.button-action.validation.text-required' | i18n }}
            </div>
          </div>

          <div class="button-action-section">
            <div class="field-label">
              <span class="required-mark">*</span>
              <span>{{ 'personal-broadcast.detail.button-action.action' | i18n }}</span>
            </div>
            <nz-select
              formControlName="action"
              class="template-action-select is-modal"
              [nzDisabled]="!messageEnabled"
              (nzValueChange)="onTemplateButtonActionChanged(btn)"
              testId="personal-broadcast-detail-button-action-select"
            >
              <nz-option *ngFor="let a of templateButtonActionOptions" [nzLabel]="a.displayLabel" [nzValue]="a.value" />
            </nz-select>
          </div>

          <ng-container *ngIf="btn.get('action')?.value === 'link'">
            <div class="button-action-panel">
              <div class="button-action-panel-title">
                <i nz-icon nzType="link" nzTheme="outline"></i>
                <span>{{ 'personal-broadcast.detail.button-action.link.title' | i18n }}</span>
              </div>
              <div class="button-action-section">
                <div class="field-label">
                  <span class="required-mark">*</span>
                  <span>{{ 'personal-broadcast.detail.button-action.link.url' | i18n }}</span>
                </div>
                <input
                  nz-input
                  formControlName="url"
                  type="url"
                  inputmode="url"
                  pattern="https?://.+"
                  required
                  [placeholder]="'personal-broadcast.detail.button-action.link.placeholder' | i18n"
                  [disabled]="!messageEnabled"
                  testId="personal-broadcast-detail-button-action-url-input"
                />
                <div
                  class="button-action-error"
                  *ngIf="showButtonConfigControlError('url', 'required') || showButtonConfigControlError('url', 'pattern')"
                >
                  {{ 'personal-broadcast.detail.button-action.validation.link-url' | i18n }}
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="btn.get('action')?.value === 'leadReason'">
            <div class="lead-reason-panel is-modal">
              <div class="lead-reason-title">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                <span>{{ 'personal-broadcast.detail.button-action.lead-reason.title' | i18n }}</span>
              </div>
              <div class="lead-reason-select-layout">
                <div class="lead-reason-select-block">
                  <div class="field-label">
                    <span class="required-mark">*</span>
                    <span>{{ 'personal-broadcast.detail.button-action.lead-reason.select' | i18n }}</span>
                  </div>
                  <nz-select
                    formControlName="leadReasonId"
                    class="lead-reason-select"
                    [nzPlaceHolder]="'personal-broadcast.detail.button-action.lead-reason.select-placeholder' | i18n"
                    [nzShowSearch]="true"
                    [nzServerSearch]="true"
                    [nzLoading]="leadReasonLoading"
                    [nzDisabled]="!messageEnabled"
                    (nzValueChange)="onLeadReasonSelected(btn)"
                    (nzOnSearch)="onLeadReasonSearch($event)"
                    (nzScrollToBottom)="onLeadReasonScrollToBottom()"
                    testId="personal-broadcast-detail-lead-reason-select"
                  >
                    <nz-option
                      *ngFor="let r of leadReasonOptions"
                      [nzLabel]="'personal-broadcast.detail.button-action.lead-reason.option' | i18n: { name: r.name, count: r.count }"
                      [nzValue]="r.id"
                    />
                  </nz-select>
                  <button
                    nz-button
                    nzType="link"
                    class="lead-reason-create-toggle"
                    (click)="toggleLeadReasonCreate()"
                    [disabled]="!messageEnabled"
                    type="button"
                    testId="personal-broadcast-detail-lead-reason-create-toggle-button"
                  >
                    {{
                      buttonActionConfigCreateVisible
                        ? ('personal-broadcast.detail.button-action.lead-reason.collapse-create' | i18n)
                        : ('personal-broadcast.detail.button-action.lead-reason.toggle-create' | i18n)
                    }}
                  </button>
                </div>

                <div class="lead-reason-detail-card" *ngIf="getSelectedLeadReason(btn) as r; else leadReasonEmpty">
                  <div class="lead-reason-detail-title">{{ 'personal-broadcast.detail.button-action.lead-reason.detail' | i18n }}</div>
                  <div class="lead-reason-detail-row">
                    <div class="lead-reason-detail-key">{{ 'personal-broadcast.detail.button-action.lead-reason.field.name' | i18n }}</div>
                    <div class="lead-reason-detail-val">{{ r.name }}</div>
                  </div>
                  <div class="lead-reason-detail-row">
                    <div class="lead-reason-detail-key">{{ 'personal-broadcast.detail.button-action.lead-reason.field.type' | i18n }}</div>
                    <div class="lead-reason-detail-val">{{ leadReasonTypeLabelI18nKey(r.sourceType) | i18n }}</div>
                  </div>
                  <div class="lead-reason-detail-row">
                    <div class="lead-reason-detail-key">{{ 'personal-broadcast.detail.button-action.lead-reason.field.desc' | i18n }}</div>
                    <div class="lead-reason-detail-val">{{ r.description || '—' }}</div>
                  </div>
                  <div class="lead-reason-detail-row">
                    <div class="lead-reason-detail-key">{{ 'personal-broadcast.detail.button-action.lead-reason.field.bizId' | i18n }}</div>
                    <div class="lead-reason-detail-val">{{ r.bizId || '—' }}</div>
                  </div>
                  <div class="lead-reason-detail-row">
                    <div class="lead-reason-detail-key">{{ 'personal-broadcast.detail.button-action.lead-reason.field.valid' | i18n }}</div>
                    <div class="lead-reason-detail-val">
                      {{
                        r.validMode === 'permanent'
                          ? ('personal-broadcast.detail.button-action.lead-reason.valid.permanent' | i18n)
                          : ('personal-broadcast.detail.button-action.lead-reason.valid.dated' | i18n)
                      }}
                      <ng-container *ngIf="r.validMode === 'dated' && r.validUntil"
                        >（{{ r.validUntil | date: 'yyyy/MM/dd' }}）</ng-container
                      >
                    </div>
                  </div>
                </div>
                <ng-template #leadReasonEmpty>
                  <div class="lead-reason-detail-empty">{{ 'personal-broadcast.detail.button-action.lead-reason.empty' | i18n }}</div>
                </ng-template>
              </div>

              <div class="lead-reason-create-panel" *ngIf="buttonActionConfigCreateVisible">
                <div class="lead-reason-fields">
                  <div class="lead-reason-field">
                    <div class="field-label">
                      <span class="required-mark">*</span>
                      <span>{{ 'personal-broadcast.detail.button-action.lead-reason.create.name' | i18n }}</span>
                    </div>
                    <input
                      nz-input
                      formControlName="leadReasonName"
                      [placeholder]="'personal-broadcast.detail.button-action.lead-reason.create.name-placeholder' | i18n"
                      [disabled]="!messageEnabled"
                      testId="personal-broadcast-detail-lead-reason-name-input"
                    />
                  </div>
                  <div class="lead-reason-field">
                    <div class="field-label">
                      <span class="required-mark">*</span>
                      <span>{{ 'personal-broadcast.detail.button-action.lead-reason.create.type' | i18n }}</span>
                    </div>
                    <nz-select
                      formControlName="leadReasonSourceType"
                      class="lead-reason-select"
                      [nzPlaceHolder]="'personal-broadcast.detail.button-action.lead-reason.create.type-placeholder' | i18n"
                      [nzDisabled]="!messageEnabled"
                      testId="personal-broadcast-detail-lead-reason-source-type-select"
                    >
                      <nz-option *ngFor="let opt of leadReasonTypeOptions" [nzValue]="opt.value" [nzLabel]="opt.labelI18nKey | i18n" />
                    </nz-select>
                  </div>

                  <div class="lead-reason-field">
                    <div class="field-label">{{ 'personal-broadcast.detail.button-action.lead-reason.field.valid' | i18n }}</div>
                    <div class="lead-reason-hint">{{ 'personal-broadcast.detail.button-action.lead-reason.create.valid-hint' | i18n }}</div>
                    <div class="lead-reason-valid">
                      <nz-radio-group
                        formControlName="leadReasonValidMode"
                        class="lead-reason-valid-group"
                        [nzDisabled]="!messageEnabled"
                        testId="personal-broadcast-detail-lead-reason-valid-mode-radio"
                      >
                        <label nz-radio nzValue="permanent">{{
                          'personal-broadcast.detail.button-action.lead-reason.valid.permanent' | i18n
                        }}</label>
                        <div class="lead-reason-dated-row">
                          <label nz-radio nzValue="dated">{{
                            'personal-broadcast.detail.button-action.lead-reason.valid.dated' | i18n
                          }}</label>
                          <nz-date-picker
                            *ngIf="btn.get('leadReasonValidMode')?.value === 'dated'"
                            formControlName="leadReasonValidUntil"
                            class="lead-reason-date"
                            nzFormat="yyyy/MM/dd"
                            nzPlaceHolder="YYYY/MM/DD"
                            [nzDisabled]="!messageEnabled || btn.get('leadReasonValidMode')?.value !== 'dated'"
                            testId="personal-broadcast-detail-lead-reason-valid-until-picker"
                          />
                        </div>
                      </nz-radio-group>
                    </div>
                  </div>

                  <button
                    nz-button
                    nzType="link"
                    class="lead-reason-advanced-toggle"
                    (click)="toggleButtonActionAdvanced()"
                    [disabled]="!messageEnabled"
                    type="button"
                    testId="personal-broadcast-detail-lead-reason-advanced-toggle-button"
                  >
                    {{
                      buttonActionConfigShowAdvanced
                        ? ('personal-broadcast.detail.button-action.lead-reason.advanced.collapse' | i18n)
                        : ('personal-broadcast.detail.button-action.lead-reason.advanced.expand' | i18n)
                    }}
                  </button>

                  <ng-container *ngIf="buttonActionConfigShowAdvanced">
                    <div class="lead-reason-field">
                      <div class="field-label">{{ 'personal-broadcast.detail.button-action.lead-reason.field.desc' | i18n }}</div>
                      <textarea
                        nz-input
                        rows="2"
                        formControlName="leadReasonDescription"
                        [placeholder]="'personal-broadcast.detail.button-action.lead-reason.advanced.desc-placeholder' | i18n"
                        [disabled]="!messageEnabled"
                        testId="personal-broadcast-detail-lead-reason-description-textarea"
                      ></textarea>
                    </div>
                    <div class="lead-reason-field">
                      <div class="field-label">{{ 'personal-broadcast.detail.button-action.lead-reason.advanced.bizId' | i18n }}</div>
                      <input
                        nz-input
                        formControlName="leadReasonBizId"
                        [placeholder]="'personal-broadcast.detail.button-action.lead-reason.advanced.bizId-placeholder' | i18n"
                        [disabled]="!messageEnabled"
                        testId="personal-broadcast-detail-lead-reason-biz-id-input"
                      />
                    </div>
                  </ng-container>
                </div>

                <div class="lead-reason-actions">
                  <button
                    nz-button
                    nzType="primary"
                    class="lead-reason-create-btn"
                    (click)="createLeadReason(btn)"
                    [disabled]="!messageEnabled"
                    type="button"
                    testId="personal-broadcast-detail-lead-reason-create-button"
                  >
                    {{ 'personal-broadcast.detail.button-action.lead-reason.create.confirm' | i18n }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </nz-modal>
</div>
